module.exports = __webpack_public_path__ + "static/media/Niranjan et al 2023 (MI).5a842c2a.pdf";